import React from 'react'

import classnames from 'classnames'

import styled from '@emotion/styled'

import tokens from '../../design/tokens'
import colors from '../../design/color-names'

export const StyledChip = styled(
  ({
    className,
    $additionalClassName,
    $clickable,
    $lg,
    $icon,
    $disabled,
    children,
    ...rest
  }) =>
    React.createElement(
      'span',
      {
        className: classnames(
          className,
          'e-chip',
          {
            'e-chip--clickable': $clickable === 'true',
            'e-chip--disabled': $disabled,
            'e-chip--lg': $lg,
            [`e-chip--${$icon}`]: $icon,
            [`${className}--clickable`]: $clickable === 'true',
            [`${className}--disabled`]: $disabled,
            [`${className}--lg`]: $lg
          },
          $additionalClassName
        ),
        ...rest
      },
      children
    )
)`
  font-size: ${tokens.fontSize.small};
  display: inline-flex;
  background: ${colors.gallery};
  padding: 4px 8px;
  line-height: 18px;
  border-radius: ${tokens.borderRadius.xsmall};
  align-items: center;
  position: relative;
  color: ${colors.tundora01};
  list-style: none;
  cursor: default;
  transition: color 0.2s ease, background-color 0.2s ease;

  & + & {
    margin-left: 8px;
  }

  &--clickable:hover {
    cursor: pointer;
    background-color: ${colors.silver01};
    color: ${colors.mineShaft};

    .e-chip__icon {
      color: ${colors.tundora};
    }
  }

  &--disabled {
    background: ${colors.alto};
    pointer-events: none;
  }
`

export const StyledChipLabel = styled.span`
  display: inline-flex;
`

export const StyledChipIconWrapper = styled(
  ({ children, className, ...rest }) =>
    React.createElement(
      'i',
      { className: classnames('e-chip__icon', className), ...rest },
      children
    )
)`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 8px;
  color: ${colors.silverChalice01};
  transition: color 0.2s ease;

  ${({ onClick }) =>
    onClick
      ? `&:hover {
    cursor: pointer;
    color: ${colors.tundora};
  }`
      : ''}
`
